export const citySelectionState = {
    isShowCitySelection: false,
    city: {
        label: '',
        value: 0
    },
    // 默认北京
    locationCity: null,
    recentCity: [],
    refreshCurrentCityCount: 0,
    cityList: [],
    cityInfos: []
};
export var CitySelectionAction;
(function (CitySelectionAction) {
    CitySelectionAction["toggleCitySelection"] = "toggleCitySelection";
    CitySelectionAction["updateCitySelection"] = "updateCitySelection";
    CitySelectionAction["updateLocationCity"] = "updateLocationCity";
    CitySelectionAction["updateRecentCity"] = "updateRecentCity";
    CitySelectionAction["refreshCurrentCity"] = "RefreshCurrentCityCount";
    CitySelectionAction["getCityList"] = "getCityList";
})(CitySelectionAction || (CitySelectionAction = {}));
export function CitySelectionReducer(state = citySelectionState, action) {
    function getCityName(cityId) {
        const cityArr = state.cityInfos;
        const city = cityArr.find(item => String(item.id) == String(cityId));
        return city ? city.name : '';
    }
    switch (action.type) {
        case CitySelectionAction.getCityList:
            const list = action.data || [];
            const allData = list.map((item) => item.data).flat();
            return Object.assign(Object.assign({}, state), { cityList: action.data, cityInfos: allData });
        case CitySelectionAction.toggleCitySelection:
            let isShowCitySelection = !state.isShowCitySelection;
            if (action.data !== undefined) {
                isShowCitySelection = action.data;
            }
            return Object.assign(Object.assign({}, state), { isShowCitySelection: isShowCitySelection });
        case CitySelectionAction.updateCitySelection:
            // 投放小程序中，有cityId，无cityName处理
            if (action.data.value && !action.data.label) {
                action.data.label = getCityName(action.data.value);
            }
            return Object.assign(Object.assign({}, state), { city: action.data });
        case CitySelectionAction.updateLocationCity:
            if (action.data.value && !action.data.label) {
                action.data.label = getCityName(action.data.value);
            }
            return Object.assign(Object.assign({}, state), { locationCity: action.data });
        case CitySelectionAction.updateRecentCity:
            return Object.assign(Object.assign({}, state), { recentCity: action.data || [] });
        case CitySelectionAction.refreshCurrentCity:
            return Object.assign(Object.assign({}, state), { refreshCurrentCityCount: state.refreshCurrentCityCount + 1 });
        default:
            return state;
    }
}
